import * as Utils from 'Assets/Utils'

import AgeRanges from 'Components/Catalogs/AgeRanges'
import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import SocioeconomicRanges from 'Components/Catalogs/SocioeconomicRanges'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Immutable.Map({}).set('Search', new Immutable.List([])).set('Response', new Immutable.Map({})).set('Get', new Immutable.Map({}));

/* Types */
export const GET_POPULATION = 'GET_POPULATION'

/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case GET_POPULATION:
			return state.set('Get', new Immutable.Map(action.Obj))
		default:
			return state;
	}
};

/* Action Creators */

export const getPopulation = (form) => {

	return (dispatch) => {

		const poblacionPorUbicacion = {
			numeroOrganizaciones: 0,
      tipoDonataria: "",
      etnias: "",
      recuperacionPromedio: "",
      atiendePoblacionIndigena: 0,
      atiendePersonasDiscapacidad: 0,
      apoyaOtrasOrganizaciones: 0,
      nombreOtrasOrganizaciones: "",
      tieneCriteriosSeleccion: 0,
      criteriosSeleccionDestinataria: ""
		}

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/getPopulation',
			method: "POST",
			data: {...form },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))

			let data = response.data

			let formPopulation = {}

			if(data.poblacion.poblacionEjercicioFiscal[0]) {

				let rangoEdad = []

				if (data.poblacion.poblacionEjercicioFiscal[0].rangosEdades) {

					rangoEdad = data.poblacion.poblacionEjercicioFiscal[0].rangosEdades.rangoEdad.map((r) => {
						return { 
							rangoEdad: r.rangoEdad, 
							subtotalMujeres: Number(r.subtotalMujeres), 
							subtotalHombres: Number(r.subtotalHombres), 
							subtotal: Number(r.subtotalMujeres) + Number(r.subtotalHombres) + Number(r.subtotalOtrosGeneros),
							esEliminado: r.esEliminado || false, 
							subtotalOtrosGeneros: Number(r.subtotalOtrosGeneros), 
							id: Utils.getUUID(), 
							idRango: Utils.getItem(AgeRanges, {id: r.rangoEdad.id}).valor 
						} 
					})
				}

				let nivelSocioeconomico = []

				if (data.poblacion.poblacionEjercicioFiscal[0].nivelesSocioeconomicos) {

					nivelSocioeconomico = data.poblacion.poblacionEjercicioFiscal[0].nivelesSocioeconomicos.nivelSocioeconomico.map((n) => {
						let nivelTemp = { 
							rangoSocioeconomico: n.rangoSocioeconomico, 
							numeroPersonas: Number(n.numeroPersonas), 
							esEliminado: n.esEliminado || false,
							numeroHombres: Number(n.numeroHombres), 
							numeroMujeres: Number(n.numeroMujeres), 
							numeroOtrosGeneros: Number(n.numeroOtrosGeneros), 
							id: Utils.getUUID(), 
							range: Utils.getItem(SocioeconomicRanges, {id: n.rangoSocioeconomico.id}).valor
						};
						if(nivelTemp.numeroHombres === 0 && nivelTemp.numeroMujeres === 0 && nivelTemp.numeroOtrosGeneros === 0)
							nivelTemp.numeroHombres = nivelTemp.numeroPersonas;
						return nivelTemp;
					})
				}

				let radio = data.poblacion.poblacionEjercicioFiscal[0].poblacionPorUbicacion.tipoDonataria || ""
				let indigenousAttention = data.poblacion.poblacionEjercicioFiscal[0].poblacionPorUbicacion.etnias || ""
				let recoveryFree = data.poblacion.poblacionEjercicioFiscal[0].poblacionPorUbicacion.recuperacionPromedio || ""

				formPopulation = {
					uniqueId: Utils.getUUID(),
					rangoEdad: rangoEdad,
					nivelSocioeconomico: nivelSocioeconomico,
					supports: data.poblacion.poblacionEjercicioFiscal[0].poblacionPorUbicacion.numeroOrganizaciones || "",
					radio: radio === "Primer piso" ? 1 : radio === "Segundo piso" ? 2 : radio === "Mixta" ? 3 : 0,
					indigenousAttention: indigenousAttention === "" ? false : true,
					specifyEtnies: indigenousAttention,
					recoveryFree: recoveryFree === "" ? false: true,
					average: recoveryFree,
					poblacionPorUbicacion: { ...poblacionPorUbicacion, ...data.poblacion.poblacionEjercicioFiscal[0].poblacionPorUbicacion }
				}

				// para las donatarias que ya existen, si las etnias vienen con datos, se escoge la pregunta de radio button como Si
				if(formPopulation.poblacionPorUbicacion.etnias)
					formPopulation.poblacionPorUbicacion.atiendePoblacionIndigena = 1

			}

			dispatch({ type: GET_POPULATION, Obj: formPopulation})
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}

export const setPopulation = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true));

		return new ClientHttpRequest({
			service: 'api/setPopulation',
			method: "POST",
			data: {...form },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false));
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error;
		});
	}
}



// WEBPACK FOOTER //
// ./src/modules/Grantees/Information/Population.js